import React from 'react';
import {
  Alert,
  Button,
  Card,
  Descriptions,
  Divider,
  Form,
  Input,
  Modal,
  Skeleton,
  Space,
  Spin,
  Typography
} from 'antd';
import axios from '../../request/axios';
import { Steps } from 'zent';
import 'zent/css/steps.css';
import ProductTypeTag from '../../components/ProductTypeTag';
import Money from '../../components/Money';
import QuantityInput from './components/QuantityInput';
import PredefinedTemplateFields from './components/PredefinedTemplateFields';
import UserDefinedTemplateFields from './components/UserDefinedTemplateFields';
import YouyuUtils from '../../utils/YouyuUtils';
import ModelConstants from '../../constants/ModelConstants';

const {Text, Link} = Typography;

class SubmitOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      product_id: this.props.match.params.product_id,
      product: null,
      quantity: null,
      show_confirm_pay: false,
      form_submitting: false
    }
  }

  componentDidMount() {
    if (this.state.product_id) {
      axios.get('products/' + this.state.product_id).then((res) => {
        const {data} = res.data;
        this.setState({
          product: data
        })
      });
    }
  }

  resetForms = () => {
    this.formRef && this.formRef.resetFields();
    if (this.chargeParamsFormRef) {
      this.chargeParamsFormRef.resetFields();
    }
    this.setState({quantity: 1, show_confirm_pay: false});
  }

  validateForm = (callback) => {
    this.formRef.validateFields().then(() => {
      if (this.chargeParamsFormRef) {
        this.chargeParamsFormRef.validateFields().then(() => {
          callback();
        })
      } else {
        callback();
      }
    })
  }

  showConfirmPay = () => {
    this.validateForm(() => {
      this.setState({show_confirm_pay: true}, () => {
        this.dealPasswordInput.focus();
      });
    })
  }

  submitOrder = () => {
    this.validateForm(() => {
      let values = this.formRef.getFieldsValue();
      values.product_id = this.state.product_id;
      values.deal_password = document.getElementById('deal_password').value;
      if (this.chargeParamsFormRef) {
        this.chargeParamsFormRef.validateFields().then(() => {
          let templateValues = this.chargeParamsFormRef.getFieldsValue();
          values = {...values, charge_params: {...templateValues}};
          this.doSubmit(values);
        });
      } else {
        this.doSubmit(values);
      }
    })
  }

  doSubmit = (params) => {
    this.setState({form_submitting: true});
    axios.post('purchase/submit-order', params).then((res) => {
      const {code, message} = res.data;
      if (code === 202) {
        Modal.confirm({
          title: '购买失败',
          content: <div>
            <div>余额不足，是否要充值？</div>
            {YouyuUtils.confirmModalDefaultProps.content}</div>,
          okText: '前往充值',
          onOk: () => {
            this.props.history.push('/charge-balance');
          }
        });
      } else if (code) {
        Modal.error({
          title: '购买失败',
          content: <div>
            <div>{message}</div>
            {YouyuUtils.confirmModalDefaultProps.content}</div>
        });
      } else {
        Modal.success({
          title: '购买成功',
          content: <Text type='secondary' style={{fontSize: '0.875em'}}>
            <Text type='secondary' style={{fontSize: '0.875em'}} code>空格</Text>查看订单，
            <Text type='secondary' style={{fontSize: '0.875em'}} code>esc</Text>继续下单</Text>,
          closable: false,
          okText: '查看订单',
          onOk: () => {
            this.props.history.push('/orders');
          },
          onCancel: () => {
            this.resetForms();
          }
        });
      }
    }).finally(() => {
      this.setState({form_submitting: false});
    });
  }

  render() {
    const {product} = this.state;
    return <Card title='我要采购' className='narrow'>
      <Steps current={1} type='breadcrumb'>
        <Steps.Step title='填写表单'/>
        <Steps.Step title='确认支付'/>
        <Steps.Step title='等待发货'/>
        <Steps.Step title='交易完成'/>
      </Steps>
      {
        product ?
          <div className='border px-8 py-4 mx-auto my-4' style={{width: 650}}>
            <Form layout='vertical' className='mt-4 form-compact' requiredMark={false}>
              <Form.Item
                label='基本信息'
              >
                <Descriptions column={2} bordered size='small' labelStyle={{width: 120}}>
                  <Descriptions.Item label='商品' span={2}><ProductTypeTag
                    value={product.type}/> {product.name} ({product.id})</Descriptions.Item>
                  <Descriptions.Item label='售价(元)'><Money value={product.price}/></Descriptions.Item>
                  <Descriptions.Item label='面值(元)'><Text>{parseFloat(product.face_value)}</Text> &nbsp;
                  </Descriptions.Item>
                  <Descriptions.Item label='购买数量限制' span={2}>{product.purchase_quantity_rule}</Descriptions.Item>
                  <Descriptions.Item label='注意事项'>
                    <div style={{maxHeight: 100, overflowY: 'auto'}}>
                      <Text>{product.description === '' ? '-' : product.description}</Text>
                    </div>
                  </Descriptions.Item>
                </Descriptions>
              </Form.Item>
            </Form>
            {
              product.params_template_type === ModelConstants.PRODUCT_TYPE.CHARGE &&
              <UserDefinedTemplateFields ref={ref => this.chargeParamsFormRef = ref}
                                         template={product.params_template}/>
            }
            {
              product.params_template_type === ModelConstants.PRODUCT_TYPE.CARD &&
              <PredefinedTemplateFields ref={ref => this.chargeParamsFormRef = ref} template={product.params_template}/>
            }
            <Form ref={ref => this.formRef = ref} onFinish={this.submitOrder} layout='vertical'
                  className='form-compact' requiredMark={false}>
              <Form.Item
                label={<Text>购买数量<Text type='secondary'>（按<Text keyboard>↑</Text><Text
                  keyboard>↓</Text>快速调整数量）</Text></Text>}
                name='quantity'
                rules={[
                  {
                    required: true,
                    message: '请输入购买数量'
                  }
                ]}
              >
                <QuantityInput onChange={(quantity) => this.setState({quantity})}
                               rule={product.purchase_quantity_rule}/>
              </Form.Item>
            </Form>
            <Divider/>
            <div className='flex justify-between'>
              <div>
                <Text>支付金额：</Text>
                {
                  (this.state.quantity && !isNaN(this.state.quantity))
                    ?
                    <Money small_decimal style={{fontSize: 20}} value={product.price * this.state.quantity}
                           prefix={<span style={{fontSize: '0.8em'}}>￥</span>}/>
                    :
                    <Text type='secondary'>-</Text>
                }
              </div>
              <div className='text-right'>
                {
                  this.state.show_confirm_pay && <Space>
                    <Input.Password id='deal_password' ref={ref => this.dealPasswordInput = ref} placeholder='输入交易密码'
                                    style={{width: 130}} onPressEnter={() => this.formRef.submit()}/>
                    <Button type='primary' danger loading={this.state.form_submitting}
                            onClick={() => this.formRef.submit()}>确认支付</Button>
                  </Space>
                }
                {
                  !this.state.show_confirm_pay && <Space>
                    <Button onClick={() => this.props.history.go(-1)}>
                      返回
                    </Button>
                    <Button type='primary' onClick={() => alert('未开通权限')}>
                      批量下单
                    </Button>
                    <Button type='primary' onClick={this.showConfirmPay}>
                      立即购买
                    </Button>
                  </Space>
                }
                {
                  this.state.show_confirm_pay && <div className='text-right mt-3'>
                    <Alert type='warning' message='请认真核对订单详情，避免错充、重复下单'/></div>
                }
              </div>
            </div>
          </div>
          :
          <div style={{width: 800, margin: '24px auto', minHeight: 400}}><Skeleton active paragraph={{rows: 8}}/></div>
      }
    </Card>
  }
}

export default SubmitOrder;